/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps, import/no-anonymous-default-export, no-useless-escape */
import {getActiveBranchId} from '../utils/branch';
import React,{useState,useEffect,useCallback} from 'react';
import Layout from '../components/layout/Layout';
import {useNavigate} from 'react-router-dom';
import SlidePanel from '../components/common/SlidePanel';
import api from '../services/api';
import {fmtDate,fmtDateTime} from '../utils/helpers';
import {useTranslation} from 'react-i18next';
import FileShaClaimButton from '../components/common/FileShaClaimButton';

// Multi-field client-side filter utility
function mfilter<T>(items: T[], query: string, fields: string[]): T[] {
  if (!query) return items;
  const q = query.toLowerCase();
  return items.filter(item =>
    fields.some(f => {
      const val = f.split('.').reduce((o: any, k) => o?.[k], item);
      return val != null && String(val).toLowerCase().includes(q);
    })
  );
}


const TRIAGE_COLORS:Record<string,string>={RED:'bg-red-600 text-white',ORANGE:'bg-orange-500 text-white',YELLOW:'bg-yellow-400 text-black',GREEN:'bg-green-500 text-white',BLUE:'bg-blue-400 text-white',BLACK:'bg-slate-800 text-white'};
const STATUS_CSS:Record<string,string>={REGISTERED:'bg-yellow-100 text-yellow-700',TRIAGED:'bg-orange-100 text-orange-700',IN_TREATMENT:'bg-blue-100 text-[#02357A]',ADMITTED:'bg-purple-100 text-purple-700',DISCHARGED:'bg-green-100 text-green-700',TRANSFERRED:'bg-slate-100 text-slate-600'};
const DISPOSITION=['DISCHARGE','ADMIT','TRANSFER','DAMA','EXPIRED','OBS_WARD'];

export default function EmergencyPage(){
  const {t}=useTranslation();
  const nav=useNavigate();
  const [cases,setCases]=useState<any[]>([]);
  const [stats,setStats]=useState<any>({});
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const [search,setSearch]=useState('');
  const [triageFilter,setTriageFilter]=useState('');
  const [selectedCase,setSelectedCase]=useState<any>(null);
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  const [showRegister,setShowRegister]=useState(false);
  const [regForm,setRegForm]=useState({patientId:'',firstName:'',lastName:'',age:'',gender:'MALE',phone:'',chiefComplaint:'',arrivalMode:'WALK_IN',triageLevel:'GREEN',isMlc:false,mlcNumber:'',notes:'',registrationFee:500,
      patientName:'',
      patientAge:'',
      patientGender:'MALE',
      patientPhone:'',
      modeOfArrival:'WALK_IN',
      referralSource:'SELF',
      attendingDoctorId:'',
      vitalsBP:'',
      vitalsHR:'',
      vitalsSpO2:'',
      vitalsTemp:'',
      vitalsRR:'',
      clinicalFindings:'',
      management:'',
      mlcCase:false,
      policeInformed:false,
      policeStation:'',
      attendantName:'',
      attendantPhone:'',
      arrivedAt:''
    ,
      vitalSigns:'{}',
      dischargedAt:'',
      registeredBy:''
    });

  const [showDetail,setShowDetail]=useState(false);
  const [showDispose,setShowDispose]=useState(false);
  const [disposeForm,setDisposeForm]=useState({disposition:'DISCHARGE',notes:'',admitWardId:''});

  const load=useCallback(async()=>{
    setLoading(true);
    try{
      const [c,s]=await Promise.all([
        api.getEmergencyCases?.({take:100}).catch(()=>({data:{data:[]}})),
        api.getEmergencyStats?.().catch(()=>({data:{}})),
      ]);
      setCases(c?.data?.data||c?.data?.cases||(Array.isArray(c?.data)?c.data:[]));
      setStats(s?.data||{});
    }catch{}
    setLoading(false);
  },[]);

  useEffect(()=>{load();},[load]);

  const register=async()=>{
    if(!regForm.chiefComplaint||!regForm.triageLevel){notify('Chief complaint and triage required');return;}
    setSaving(true);
    try{
      await api.registerEmergencyCase?.({...regForm,branchId:getActiveBranchId()||undefined});
      notify('Emergency case registered!');setShowRegister(false);await load();
    }catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
    setSaving(false);
  };

  const dispose=async()=>{
    if(!selectedCase)return;
    setSaving(true);
    try{
      await api.disposeEmergencyCase?.(selectedCase.id,disposeForm);
      notify('Case disposed!');setShowDispose(false);setShowDetail(false);await load();
    }catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
    setSaving(false);
  };

  const filtered=cases.filter((c:any)=>{
    const name=`${c.first_name||''} ${c.last_name||''} ${c.uhid||''} ${c.case_number||''}`.toLowerCase();
    return(!search||name.includes(search.toLowerCase()))&&(!triageFilter||c.triage_level===triageFilter);
  });

  return(
    <Layout title="Emergency Department" actions={
      <button onClick={()=>nav('/emergency/register')} className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 px-5 rounded-xl transition-all text-sm shadow-md shadow-red-500/20 disabled:opacity-50">+ Register Emergency Case</button>
    }>
      {msg&&<div className="fixed top-5 right-5 z-[99999] px-5 py-3 rounded-2xl shadow-xl text-sm font-semibold bg-white border border-slate-200">{msg}</div>}

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-4">
        {[['Total Cases',stats.totalCases||cases.length,'slate'],['Active',stats.active||cases.filter((c:any)=>!['DISCHARGED','TRANSFERRED','EXPIRED'].includes(c.status)).length,'blue'],['RED Triage',stats.red||cases.filter((c:any)=>c.triage_level==='RED').length,'red'],['MLC Cases',stats.mlc||cases.filter((c:any)=>c.is_mlc).length,'amber'],['Discharged',stats.discharged||cases.filter((c:any)=>c.status==='DISCHARGED').length,'green']].map(([l,v,c])=>(
          <div key={String(l)} className="bg-white rounded-2xl border border-slate-200 shadow-sm p-3 text-center"><p className="text-xs text-slate-400">{l}</p><p className={`text-2xl font-bold text-${c}-600`}>{v}</p></div>
        ))}
      </div>

      {/* Triage filter tabs */}
      <div className="flex gap-2 mb-4 flex-wrap">
        {[['','All'],['RED','🔴 Red'],['ORANGE','🟠 Orange'],['YELLOW','🟡 Yellow'],['GREEN','🟢 Green'],['BLUE','🔵 Blue']].map(([v,l])=>(
          <button key={v} onClick={()=>setTriageFilter(v)} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${triageFilter===v?'bg-[#02357A] text-white':'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>{l}</button>
        ))}
        <input className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-[#02357A] focus:ring-2 focus:ring-[#02357A]/10 transition-all placeholder:text-slate-400 text-sm flex-1 min-w-32" placeholder="Search case..." value={search} onChange={e=>setSearch(e.target.value)}/>
      </div>

      {/* Cases table */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="grid grid-cols-10 p-3 bg-slate-50 border-b text-xs font-semibold text-slate-500 uppercase gap-2">
          <span>Case No</span><span className="col-span-2">{t('common.patient','Patient')}</span><span>Triage</span><span className="col-span-2">Chief Complaint</span><span>Arrival</span><span>Mode</span><span>{t('common.status','Status')}</span><span>{t('common.actions','Actions')}</span>
        </div>
        {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
        :filtered.length===0?<div className="p-8 text-center text-slate-400">No emergency cases</div>
        :<div className="divide-y max-h-[60vh] overflow-y-auto">
          {filtered.map((c:any)=>(
            <div key={c.id} className="grid grid-cols-10 gap-2 p-3 items-center hover:bg-slate-50 text-sm">
              <span className="font-mono text-xs text-[#02357A]">{c.case_number||c.id?.slice(0,8)}</span>
              <div className="col-span-2">
                <p className="font-semibold">{c.first_name} {c.last_name}</p>
                <p className="text-xs text-slate-400">{c.age||'?'}y {c.gender||''} {c.is_mlc?'⚠️ MLC':''}</p>
              </div>
              <span className={`px-2 py-1 rounded text-xs font-bold ${TRIAGE_COLORS[c.triage_level]||'bg-slate-100'}`}>{c.triage_level}</span>
              <span className="col-span-2 text-xs truncate">{c.chief_complaint}</span>
              <span className="text-xs text-slate-400">{fmtDateTime(c.created_at)}</span>
              <span className="text-xs">{c.arrival_mode?.replace('_',' ')}</span>
              <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-600">{c.status||'REGISTERED'}</span>
              <div className="flex gap-1">
                <button onClick={()=>{setSelectedCase(c);setShowDetail(true);}} className="text-xs text-[#02357A] hover:underline">{t('common.view','View')}</button>
                <button onClick={()=>{setSelectedCase(c);setDisposeForm({disposition:'DISCHARGE',notes:'',admitWardId:''});setShowDispose(true);}} className="text-xs text-green-600 hover:underline">Dispose</button>
              </div>
            </div>
          ))}
        </div>}
      </div>

      {/* Case Detail */}
      <SlidePanel isOpen={showDetail&&!!selectedCase} onClose={()=>setShowDetail(false)} title={`Case — ${selectedCase?.case_number||''}`} icon="📋" size="lg">
        {selectedCase&&(
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-2">
              {[['Patient',`${selectedCase.first_name||''} ${selectedCase.last_name||''}`],['Triage',selectedCase.triage_level],['Chief Complaint',selectedCase.chief_complaint],['Arrival Mode',selectedCase.arrival_mode],['MLC',selectedCase.is_mlc?'Yes':'No'],['Status',selectedCase.status]].map(([l,v])=>(
                <div key={String(l)} className="bg-slate-50 rounded p-2"><p className="text-xs text-slate-400">{l}</p><p className="font-medium text-sm">{v||'—'}</p></div>
              ))}
            </div>
            <FileShaClaimButton
              patientId={selectedCase.patient_id||selectedCase.patientId||''}
              patientName={`${selectedCase.first_name||selectedCase.patient_name||''} ${selectedCase.last_name||''}`.trim()}
              encounterId={selectedCase.id}
              serviceName={selectedCase.chief_complaint||'Emergency'}
              serviceType="EMERGENCY"
              from="emergency"
              className="w-full text-sm font-semibold py-2.5 rounded-xl bg-[#039089] text-white"
            />
            <button onClick={()=>{setDisposeForm({disposition:'DISCHARGE',notes:'',admitWardId:''});setShowDispose(true);}} className="bg-[#02357A] hover:bg-[#015CA6] text-white font-semibold py-2.5 px-5 rounded-xl transition-all text-sm shadow-md shadow-[#02357A]/20 disabled:opacity-50 disabled:cursor-not-allowed w-full">Dispose Patient</button>
          </div>
        )}
      </SlidePanel>

      {/* Dispose */}
      <SlidePanel isOpen={showDispose} onClose={()=>setShowDispose(false)} title="Dispose Emergency Case" icon="✅"
        actions={<button onClick={dispose} disabled={saving} className="bg-[#02357A] hover:bg-[#015CA6] text-white font-semibold py-2.5 px-5 rounded-xl transition-all text-sm shadow-md shadow-[#02357A]/20 disabled:opacity-50 disabled:cursor-not-allowed w-full">{saving?'Processing...':'Confirm Disposition'}</button>}>
        <div className="space-y-3">
          <div><label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">Disposition *</label>
            <select value={disposeForm.disposition} className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-[#02357A] focus:ring-2 focus:ring-[#02357A]/10 transition-all placeholder:text-slate-400" onChange={e=>setDisposeForm({...disposeForm,disposition:e.target.value})}>
              {DISPOSITION.map(d=><option key={d}>{d}</option>)}
            </select>
          </div>
          <div><label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5">Notes / Instructions</label><textarea className="w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-[#02357A] focus:ring-2 focus:ring-[#02357A]/10 transition-all placeholder:text-slate-400 w-full" rows={3} value={disposeForm.notes} onChange={e=>setDisposeForm({...disposeForm,notes:e.target.value})} placeholder="Discharge instructions, referral details..."/></div>
        </div>
      </SlidePanel>
    </Layout>
  );
}
